import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { CardFooter } from "reactstrap";
import { TextRupiah } from "../Text";
export default class SneakerFooter extends Component {
  renderLatestPrice() {
    return (
      <div className="sneaker-price">
        <div className="price-tag-wrapper">
          {
            this.props.category === "handbags" ?
            <span className="price-tag brand">{this.props.brand_title}</span> : null
          }
          <h2 className="price-tag">{this.props.title}</h2>
        </div>
        {/* {this.props.category === "lifestyles" && this.props.subCategory ? (
          <div className="sub-category-wrapper">
            <span>
              {this.props.subCategory.length > 0
                ? this.props.subCategory[0]
                : null}
            </span>
          </div>
        ) : null} */}
        {
          this.props.latestPrice === null?
          <div className="sneaker-price">
            <p
              className="text-danger text-center text-bold"
              style={{ margin: 0 }}
            >
              {this.props.statusPage === "unreleased"? "Coming Soon" : "Out of Stock"}
            </p>
          </div>
        :
        <>
          {/* <div className="price-label-wrapper">
            <span className="price-label">starts from</span>
          </div> */}
          <TextRupiah
            value={this.props.latestPrice.total_subsidy > 0? this.props.latestPrice.total_subsidy : this.props.latestPrice.asking_price}
            prefix="IDR "
            className="price-tag"
            color="black"
            bold={true}
            isOnlyKickPoint={this.props.isOnlyKickPoint}
          />
        </>
        }
      </div>
    );
  }
  render() {
    return (
      <CardFooter
        className="wrapper-footer"
        style={{ background: "transparent", border: "none" }}
      >
        {this.renderLatestPrice()}
      </CardFooter>
    );
  }
}
